import { Tab, TabProps, Tabs, TabsOwnProps, TabsProps } from '@mui/material';
import { TabsClass } from '@shared/styles';
import { a11yProps } from '@shared/utils';

/* Use the same id as TabPanel */
interface Props {
  id: string;
  tabs: Array<
    Pick<TabProps, 'label' | 'value' | 'icon'> & { isHighlighted?: boolean; disabled?: boolean }
  >;
  currentTab: string | number;
  onChange: TabsProps['onChange'];
  isHighlighted?: boolean;
  variant?: TabsOwnProps['variant'];
  sx?: TabsProps['sx'];
}

const className = TabsClass.underlined;

export default function UnderlinedTabs({
  id,
  tabs,
  currentTab,
  variant = 'scrollable',
  onChange,
  sx,
}: Props) {
  return (
    <Tabs
      value={currentTab}
      onChange={onChange}
      className={className}
      variant={variant}
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={sx}
    >
      {tabs.map(({ label, value, icon, isHighlighted, disabled }, index) => (
        <Tab
          key={`${id}-${value || index}`}
          label={label}
          value={value || index}
          icon={icon}
          {...a11yProps(id, value || index)}
          className={className}
          disabled={disabled}
          sx={{ fontWeight: isHighlighted ? 700 : undefined }}
        />
      ))}
    </Tabs>
  );
}
